import React, { useEffect } from 'react';
import { APP_NAME } from '../../support/brand';
import { COMPANY_NAME, COMPANY_CNPJ, COMPANY_EMAIL } from '../../support/legal';
import LegalPageLayout, { LegalSection } from '../../components/legal/LegalPageLayout';

function TermsOfService() {
  useEffect(() => {
    document.title = `Termos de Uso — ${APP_NAME}`;
  }, []);

  return (
    <LegalPageLayout title="Termos de Uso">
      <LegalSection title="1. Aceitação dos termos">
        <p>
          Ao acessar ou utilizar a plataforma {APP_NAME}, operada pela {COMPANY_NAME} (CNPJ{' '}
          {COMPANY_CNPJ}), você concorda com estes Termos de Uso. Se não concordar com qualquer
          disposição, não utilize o serviço.
        </p>
      </LegalSection>

      <LegalSection title="2. Descrição do serviço">
        <p>
          O {APP_NAME} é uma plataforma para criação e gestão de agentes de inteligência
          artificial, incluindo:
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Configuração de agentes e sub-agentes com instruções personalizadas.</li>
          <li>Bases de conhecimento para recuperação de informações (RAG).</li>
          <li>Integrações com canais de comunicação, como WhatsApp.</li>
          <li>Agendamento e envio de mensagens proativas.</li>
          <li>Conexão com servidores MCP e outros provedores de IA.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Cadastro e responsabilidade da conta">
        <p>
          Para utilizar a plataforma, é necessário criar uma conta com informações verdadeiras e
          atualizadas. Você é responsável por manter a confidencialidade das credenciais de acesso
          e por todas as atividades realizadas em sua conta e workspace.
        </p>
        <p>
          Notifique-nos imediatamente em caso de uso não autorizado da sua conta pelo e-mail{' '}
          <a href={`mailto:${COMPANY_EMAIL}`} className="text-forge-600 hover:underline">
            {COMPANY_EMAIL}
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="4. Uso aceitável">
        <p>Você concorda em não utilizar a plataforma para:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Atividades ilegais ou que violem direitos de terceiros.</li>
          <li>Envio de spam, mensagens não solicitadas ou conteúdo abusivo.</li>
          <li>Distribuição de malware, tentativas de invasão ou ataques à infraestrutura.</li>
          <li>Geração ou disseminação de conteúdo discriminatório, difamatório ou fraudulento.</li>
          <li>Violação de leis de proteção de dados ou privacidade aplicáveis.</li>
        </ul>
        <p>
          Reservamo-nos o direito de suspender ou encerrar contas que violem estas regras, sem
          prejuízo de medidas legais cabíveis.
        </p>
      </LegalSection>

      <LegalSection title="5. Conteúdo do usuário">
        <p>
          Você mantém a propriedade do conteúdo que insere na plataforma, incluindo bases de
          conhecimento, instruções de agentes e configurações. Ao utilizar o serviço, você nos
          concede licença limitada para processar esse conteúdo com a finalidade de operar a
          plataforma e gerar respostas dos agentes de IA.
        </p>
        <p>
          Você é integralmente responsável pelo conteúdo inserido e pelas interações dos agentes
          configurados por você, incluindo mensagens enviadas a contatos via integrações.
        </p>
      </LegalSection>

      <LegalSection title="6. Integrações de terceiros">
        <p>
          A plataforma permite integração com serviços de terceiros, como WhatsApp, servidores MCP
          e provedores de modelos de linguagem. O uso dessas integrações está sujeito aos termos e
          políticas dos respectivos provedores.
        </p>
        <p>
          Não nos responsabilizamos por indisponibilidades, alterações ou restrições impostas por
          terceiros que possam afetar o funcionamento das integrações.
        </p>
      </LegalSection>

      <LegalSection title="7. Propriedade intelectual">
        <p>
          A plataforma {APP_NAME}, incluindo software, design, marca e documentação, é de
          propriedade da {COMPANY_NAME} ou de seus licenciadores. Nenhuma disposição nestes termos
          transfere direitos de propriedade intelectual sobre a plataforma ao usuário.
        </p>
        <p>
          O conteúdo inserido pelo usuário permanece de propriedade do usuário, conforme descrito
          na seção 5.
        </p>
      </LegalSection>

      <LegalSection title="8. Disponibilidade e limitações">
        <p>
          O serviço é fornecido &quot;como está&quot;, sem garantias de disponibilidade
          ininterrupta. Podemos realizar manutenções programadas ou emergenciais que resultem em
          indisponibilidade temporária.
        </p>
        <p>
          Respostas geradas por agentes de IA podem conter imprecisões. Recomendamos revisão humana
          antes de tomar decisões com base em conteúdo gerado automaticamente.
        </p>
      </LegalSection>

      <LegalSection title="9. Suspensão e encerramento">
        <p>
          Você pode encerrar sua conta a qualquer momento, entrando em contato pelo e-mail{' '}
          <a href={`mailto:${COMPANY_EMAIL}`} className="text-forge-600 hover:underline">
            {COMPANY_EMAIL}
          </a>
          . Podemos suspender ou encerrar contas que violem estes termos, sem aviso prévio, quando
          necessário para proteger a plataforma ou outros usuários.
        </p>
      </LegalSection>

      <LegalSection title="10. Limitação de responsabilidade">
        <p>
          Na máxima extensão permitida pela lei aplicável, a {COMPANY_NAME} não será responsável
          por danos indiretos, incidentais, especiais ou consequenciais decorrentes do uso ou da
          impossibilidade de uso da plataforma.
        </p>
        <p>
          Nossa responsabilidade total, em qualquer hipótese, limita-se ao valor pago pelo usuário
          pelos serviços nos 12 (doze) meses anteriores ao evento que originou a reclamação, quando
          aplicável.
        </p>
      </LegalSection>

      <LegalSection title="11. Alterações nos termos">
        <p>
          Podemos modificar estes Termos de Uso a qualquer momento. A data da última atualização
          será indicada no topo desta página. O uso continuado da plataforma após alterações
          constitui aceitação dos novos termos.
        </p>
      </LegalSection>

      <LegalSection title="12. Lei aplicável e foro">
        <p>
          Estes termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o
          foro da comarca do domicílio da {COMPANY_NAME} para dirimir quaisquer controvérsias,
          com renúncia a qualquer outro, por mais privilegiado que seja.
        </p>
      </LegalSection>

      <LegalSection title="13. Contato">
        <p>Para dúvidas sobre estes Termos de Uso, entre em contato:</p>
        <p>
          <strong>{COMPANY_NAME}</strong>
          <br />
          CNPJ: {COMPANY_CNPJ}
          <br />
          E-mail:{' '}
          <a href={`mailto:${COMPANY_EMAIL}`} className="text-forge-600 hover:underline">
            {COMPANY_EMAIL}
          </a>
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}

export default TermsOfService;
